import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer = ({ onOpenPolicy }) => {
  const [policies, setPolicies] = useState([]);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_URL || 'https://prox.mycartly.in/api';
        const response = await fetch(`${baseUrl}/landing/policies`);
        const result = await response.json();
        if (result.success) {
          setPolicies(result.data);
        }
      } catch (error) {
        console.error('Error fetching policies:', error);
      }
    };
    fetchPolicies();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-contact-section">
          <p className="footer-contact-text">Feel free to reach us at:</p>
          <div className="footer-contact-buttons">
            <a href="mailto:support@proxhelp.com" className="footer-contact-button">
              <svg className="footer-contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>support@proxhelp.com</span>
            </a>
            <a href="tel:+918882173163" className="footer-contact-button">
              <svg className="footer-contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92V19.92C22 20.47 21.55 20.92 21 20.92C11.61 20.92 4 13.31 4 3.92C4 3.37 4.45 2.92 5 2.92H8C8.55 2.92 9 3.37 9 3.92V6.62C9 7.07 8.78 7.49 8.35 7.74L6.96 8.54C8.25 11.13 10.37 13.25 12.96 14.54L13.76 13.15C14.01 12.72 14.43 12.5 14.88 12.5H17.58C18.13 12.5 18.58 12.95 18.58 13.5V16.5C18.58 16.73 18.49 16.94 18.34 17.11C18.18 17.29 17.96 17.39 17.72 17.39" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>+91 8882173163</span>
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-content">
          <div className="footer-links-left">
            {policies.map((policy) => (
              <button
                key={policy.slug}
                className="footer-link-btn"
                onClick={() => onOpenPolicy(policy)}
              >
                {policy.title}
              </button>
            ))}
            {!policies.length && (
              <>
                <a href="#terms" className="footer-link">Terms & conditions</a>
                <a href="#privacy" className="footer-link">Privacy Policy</a>
              </>
            )}
          </div>

          <div className="footer-links-right">
            <a href="#support" className="footer-link">Support</a>
            <a href="mailto:career@proxhelp.com" className="footer-link">Join us: career@proxhelp.com</a>
          </div>

          <div className="footer-right-section">
            <p className="footer-copyright">Copyright © 2026, ProxHelp Technologies Pvt. Ltd. All Rights Reserved</p>
            <div className="footer-social-icons">
              {/* Social icons kept exactly as they were */}
              <a href="https://www.linkedin.com/company/proxhelp" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M6 9H2V21H6V9Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="https://www.facebook.com/proxhelp" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17V10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="https://www.instagram.com/proxhelp" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5932 15.1514 13.8416 15.5297C13.0901 15.9079 12.2385 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61993 14.1902 8.22774 13.4229 8.09408 12.5922C7.96042 11.7615 8.09208 10.9099 8.47034 10.1584C8.8486 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.1283C15.4785 9.73514 15.8741 10.5211 16 11.37Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M17.5 6.5H17.51" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="https://www.youtube.com/@proxhelp" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="YouTube">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.54 6.42C22.4212 5.94541 22.1793 5.51057 21.8387 5.15941C21.4981 4.80824 21.0707 4.55318 20.6 4.42C18.88 4 12 4 12 4C12 4 5.12 4 3.4 4.42C2.92925 4.55318 2.50187 4.80824 2.16129 5.15941C1.82071 5.51057 1.57879 5.94541 1.46 6.42C1.14521 8.16351 0.991235 9.93322 1 11.705C0.991235 13.4768 1.14521 15.2465 1.46 16.99C1.57879 17.4646 1.82071 17.8994 2.16129 18.2506C2.50187 18.6018 2.92925 18.8568 3.4 18.99C5.12 19.41 12 19.41 12 19.41C12 19.41 18.88 19.41 20.6 18.99C21.0707 18.8568 21.4981 18.6018 21.8387 18.2506C22.1793 17.8994 22.4212 17.4646 22.54 16.99C22.8548 15.2465 23.0088 13.4768 23 11.705C23.0088 9.93322 22.8548 8.16351 22.54 6.42Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.75 15.02L15.5 11.705L9.75 8.39V15.02Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="https://x.com/Proxhelp" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23 3C22.0424 3.67548 20.9821 4.19211 19.88 4.53C19.3672 3.83751 18.6693 3.34669 17.872 3.12393C17.0747 2.90116 16.2276 2.95791 15.4587 3.28666C14.6898 3.6154 14.0393 4.20046 13.601 4.96353C13.1627 5.72659 12.9569 6.62279 13.01 7.53V8.53C11.2426 8.57557 9.50127 8.18581 7.93101 7.39545C6.36074 6.60508 5.01032 5.43864 4 4C4 4 -1 13 8 17C5.94053 18.398 3.48716 19.099 1 19C10 24 21 19 21 7.5C20.9991 7.22145 20.9723 6.94359 20.92 6.67C21.9406 5.66349 22.6608 4.39271 23 3Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

